module.exports = __webpack_public_path__ + "first-5_front.jpg?799296764715a62d1d182ff1f204cb18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5_front.jpg
// module id = 581
// module chunks = 0